import { storableError } from '../../../../util/errors';

import {
  getExtendedTransactionData,
} from '../../../../util/api';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ExtendedProfileContent/CLEAR_UPDATED_FORM';

export const FETCH_EXTENDED_PROFILE_REQUEST = 'app/ExtendedProfileContent/FETCH_EXTENDED_PROFILE_REQUEST';
export const FETCH_EXTENDED_PROFILE_SUCCESS = 'app/ExtendedProfileContent/FETCH_EXTENDED_PROFILE_SUCCESS';
export const FETCH_EXTENDED_PROFILE_ERROR = 'app/ExtendedProfileContent/FETCH_EXTENDED_PROFILE_ERROR';


// ================ Reducer ================ //

const initialState = {
  extendedTransactionData: null,
  fetchExtendedProfileInProgress: false,
  fetchExtendedProfileError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_EXTENDED_PROFILE_REQUEST:
      return {
        ...state,
        fetchExtendedProfileInProgress: true,
        fetchExtendedProfileError: null,
      };
    case FETCH_EXTENDED_PROFILE_SUCCESS:
      return {
        ...state,
        extendedTransactionData: payload,
        fetchExtendedProfileInProgress: false,
      };
    case FETCH_EXTENDED_PROFILE_ERROR:
      return {
        ...state,
        extendedTransactionData: null,
        fetchExtendedProfileInProgress: false,
        fetchExtendedProfileError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

export const fetchExtendedDataRequest = params => ({
  type: FETCH_EXTENDED_PROFILE_REQUEST,
  payload: { params },
});
export const fetchExtendedDataSuccess = result => ({
  type: FETCH_EXTENDED_PROFILE_SUCCESS,
  payload: result,
});
export const fetchExtendedDataError = error => ({
  type: FETCH_EXTENDED_PROFILE_ERROR,
  payload: error,
  error: true,
});


// ================ Thunk ================ //

export const fetchDataForTransaction = (transaction_id) => (dispatch, getState) => {
  if (transaction_id) {
    dispatch(fetchExtendedDataRequest());

    return getExtendedTransactionData(transaction_id)
      .then(response => {
        dispatch(fetchExtendedDataSuccess(response));
        return response;
      })
      .catch(e => {
        dispatch(fetchExtendedDataError(storableError(e)));
        throw e;
      });
  }

  console.warn("User ID not found");
  return Promise.resolve();
};
